import { Declaration } from 'store/declarations/declaration';
import DeclarationTabKeys from './DeclarationTabKeys';
import { declarationIsCompleted } from './declaration-utils';
import { declarationHasBeenSubmitted } from './form-utils';

export const getDeclarationFormTabKeys = (declaration: Declaration | undefined): DeclarationTabKeys[] => {
    if (declarationIsCompleted(declaration)) {
        return [DeclarationTabKeys.SUMMARY, DeclarationTabKeys.VIEW_ONLY];
    }

    if (declaration?.status && declarationHasBeenSubmitted(declaration.status)) {
        return [DeclarationTabKeys.VIEW_ONLY];
    }

    return [DeclarationTabKeys.FORM];
};
